import {
  updateAxesQueryParam,
  toggleAxesEdited,
} from '../../../../redux/ChartPoperties/ChartPropertiesActions';
import { chartFilterGroupEdited } from '../../../../redux/ChartFilterGroup/ChartFilterGroupStateActions';
import { setDisplayName } from '../../../ChartAxes/setDisplayName';
import { setPrefix } from '../../../ChartAxes/SetPrefix';
import { findNewDisplayName } from '../../../CommonFunctions/CommonFunctions';
import ChartsInfo from '../../../ChartAxes/ChartsInfo2';
import {
  callQueryAPI,
  updateFormatOption,
} from '../../../../redux/ChartPoperties/ChartControlsActions';
import { IFlows } from '../../../../redux/Calculations/CurrentCalculationSessionInterface';

export const handleAggregatedCalculation = (
  session: any,
  calcInfo: any,
  chartProperties: any,
  tableInfo: any,
  dispatch: any,
  chartControls: any,
  datatype: string,
) => {
  const allPropKeys = Object.keys(chartProperties?.properties);
  // const allGroupKeys = Object.keys(chartGroup?.groups);
  let calcHasWindowFn = false;
  let calcHasOverride = false;
  Object.values(calcInfo.flows as IFlows).some((steps) =>
    steps.some((step) => {
      if (!step.flowOverride) {
        calcHasOverride = false;
      } else if (
        step.flowOverride.dimension.type !== 'honorAll' ||
        step.flowOverride.filter.type !== 'honorAll'
      ) {
        calcHasOverride = true;
      } else {
        calcHasOverride = false;
      }
      if (step.flowOverride?.windowFunction) {
        calcHasWindowFn = true;
      }

      if (calcHasWindowFn && calcHasOverride) return true;
      return false;
    }),
  );
  const apiCalledTriggeredForPropKey: string[] = [];
  for (const eachPropKey of allPropKeys) {
    /**
     * as of now aggregated calculation is allowed only in Measure X and Y axis so no need to loop through dimensions
     */
    const chartType = chartProperties?.properties[eachPropKey]?.chartType;
    /**
     *
     *
     * No need to update override part as aggregated calcualtion cant be dropped in  override   axis
     *
     */
    let ignorredNames: string[] = [];
    chartProperties?.properties[eachPropKey]?.chartAxes.forEach((ax: any, axId: number) => {
      ax?.fields?.forEach((field: any, fieldId: number) => {
        if (field.SavedCalculationUUID === session.uuid) {
          dispatch(toggleAxesEdited(eachPropKey, true));
          dispatch(chartFilterGroupEdited(true));

          const newFieldData = setDisplayName(
            setPrefix(
              {
                ...field,
                fieldname: calcInfo.calculatedFieldName,
                displayname: field.isTextRenamed ? field.displayname : calcInfo.calculatedFieldName,
              },
              ax.name,
              chartType,
            ),
            ax.name,
            chartType,
          );
          if (field.windowfn && (calcHasWindowFn || calcHasOverride)) newFieldData.windowfn = null;
          if(field.override && (calcHasWindowFn|| calcHasOverride))newFieldData.override=null
          if (!field.isTextRenamed && field.fieldname !== calcInfo.calculatedFieldName) {
            newFieldData.displayname = findNewDisplayName(
              chartProperties?.properties[eachPropKey]?.chartAxes,
              newFieldData,
              chartControls.properties?.[eachPropKey]?.formatOptions?.tooltipFormats,
              ignorredNames,
            );
            if (!ignorredNames.includes(newFieldData.displayname))
              ignorredNames.push(newFieldData.displayname);
          }

          dispatch(
            updateAxesQueryParam(
              eachPropKey,
              axId,
              fieldId,
              {
                ...newFieldData,
                dataType: datatype,
                tableId: tableInfo.id,
                uId: field.uId,
                agg: field.agg,
                displayname: field.isTextRenamed ? field.displayname : newFieldData.displayname,
                SavedCalculationUUID: session.uuid || null,
                isTextRenamed: field.isTextRenamed ?? false,
                isCalculatedField: true,
                isAggregated: true,
                hasOverridedFlow:
                  calcInfo.overrideCount > 0 ,
              },
              'chartAxes',
            ),
          );
          if (!apiCalledTriggeredForPropKey.includes(eachPropKey)) {
            apiCalledTriggeredForPropKey.push(eachPropKey);
            dispatch(callQueryAPI(eachPropKey, true));
          }
        }
      });
    });

    /****************************************
     ***UPDATE TOOLTIP EXTRA MEASURE**
     ****************************************/

    /** extraMeasureField willl be always be array of 1 element  */
    const extraMeasureFields =
      chartControls?.properties[eachPropKey]?.formatOptions?.tooltipFormats?.extraMeasureField;
    if (!extraMeasureFields) continue;
    const fields = extraMeasureFields[0].fields; // 0 index to get the first element
    if (!fields) continue;
    let updated = false;
    const newFields = fields.map((field: any) => {
      /**no need to cehck for override part as we cant drop   aggregated calc in override
       *
       */
      if (field.SavedCalculationUUID === session.uuid) {
        updated = true;

        const newFieldData = setDisplayName(
          setPrefix(
            {
              ...field,
              fieldname: calcInfo.calculatedFieldName,
              displayname: field.isTextRenamed ? field.displayname : calcInfo.calculatedFieldName,
            },
            'Measure',
            chartType,
          ),
          'Measure',
          chartType,
        );
        if (field.windowfn && (calcHasWindowFn || calcHasOverride)) newFieldData.windowfn = null;
        if (field.override &&(calcHasWindowFn|| calcHasOverride)) newFieldData.override = null;
        if (!field.isTextRenamed && field.fieldname !== calcInfo.calculatedFieldName) {
          newFieldData.displayname = findNewDisplayName(
            chartProperties?.properties[eachPropKey]?.chartAxes,
            newFieldData,
            chartControls.properties?.[eachPropKey]?.formatOptions?.tooltipFormats,
            ignorredNames,
          );
          if (!ignorredNames.includes(newFieldData.displayname))
            ignorredNames.push(newFieldData.displayname);
        }
        return {
          ...newFieldData,
          dataType: datatype,
          tableId: tableInfo.id,
          uId: field.uId,
          agg: field.agg,
          displayname: field.isTextRenamed ? field.displayname : newFieldData.displayname,
          SavedCalculationUUID: session.uuid || null,
          isTextRenamed: field.isTextRenamed ?? false,
          isCalculatedField: true,
          isAggregated: true,
          hasOverridedFlow: calcInfo.overrideCount > 0 ,
        };
      } else return field;
    });
    if (updated) {
      extraMeasureFields[0].fields = newFields;
      dispatch(
        updateFormatOption(eachPropKey, 'tooltipFormats', 'extraMeasureField', extraMeasureFields),
      );
      if (!apiCalledTriggeredForPropKey.includes(eachPropKey)) {
        apiCalledTriggeredForPropKey.push(eachPropKey);
        dispatch(callQueryAPI(eachPropKey, true));
      }
    }
  }
  /***
   *
   *
   * as of now aggregated acalculation is not allowed in filter group so this loop will cause performance issue
   */
  // for (const eachGroupKey of allGroupKeys) {
  //   chartGroup?.groups[eachGroupKey]?.filters?.forEach((filter: any, filterId: number) => {
  //     if (filter.SavedCalculationUUID === session.uuid) {
  //       dispatch(
  //         updateChartFilterField(eachGroupKey, filterId, {
  //           fieldname: calcInfo.calculatedFieldName || '',
  //           displayname: calcInfo.displayFieldName || '',
  //           tableId: tableInfo.id,
  //         })
  //       );
  //     }
  //   });
  // }
};
